import { getFloat } from '../../../../helper'

export const formatValueToString = (value) => {
	return (getFloat(value || 0).toFixed(2).replace('.', ',')).toString()
}
